import { useMemo } from "react";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import { isNonEmptyString } from "src/services/predicates";
import { useOrgConfig } from "./useOrgConfig";

export function usePaymentConfig() {
  const paymentConfigRD = useOrgConfig<OrgConfig.Payments>(
    "Payments",
    OrgConfig.PaymentsSchema.default
  );

  return useMemo(
    () =>
      paymentConfigRD.map((paymentConfig) => {
        return {
          isPaymentConfigured:
            paymentConfig.enabled && isNonEmptyString(paymentConfig.accountId),
          config: paymentConfig,
        };
      }),
    [paymentConfigRD]
  );
}
